module.exports = __webpack_public_path__ + "static/media/63 - Toro Y Moi - Girl Like You.55553d6e.mp3";